<template>
  <div class="filter-input-value">
    <div class="setup-input" v-if="showSelectValueOrFieldTpl">
      <el-select
        v-model="inputType"
        :disabled="(isShareFilter && isFromRoma) || globalFieldsMapItem.isQueryField || $attrs.disabled"
        @change="inputTypeChange"
        class="left-input w-[120px]"
        size="mini"
      >
        <el-option :label="item.label" :value="item.value" v-for="item in optionsValueView"></el-option>
      </el-select>
      <div v-if="inputType === 'field'">
        <el-select
          v-model="filterItem.rightFilterField"
          v-if="!isFieldsGroup"
          @change="rightTableChange"
          class="right-input"
          filterable
          placeholder="请选择字段"
          size="mini"
          :disabled="$attrs.disabled"
        >
          <el-option v-for="item in fieldListView" :key="item.value" :label="item.label" :value="item.field"></el-option>
        </el-select>
        <el-cascader
          :ref="`filterItem${$attrs.groupIndex}${$attrs.filterItemIndex}`"
          v-model="filterItem.rightFilterField"
          v-else
          @change="(val) => rightTableChange(val, `filterItem${$attrs.groupIndex}${$attrs.filterItemIndex}`)"
          :props="{ emitPath: false, ...$attrs.customProps, ...localProps }"
          :class="[
            `filterItem${$attrs.groupIndex}${$attrs.filterItemIndex}`,
            'w210',
            { 'ml6': !codeList.length },
            { 'err-select': judgeDelete() },
          ]"
          size="mini"
          :options="!!codeList.length ? codeList : fieldListView"
          :show-all-levels="false"
          :before-filter="chooseFirstOption"
          :filter-method="filterNode"
          filterable
          clearable
          :separator="separatorSymbol"
          @visible-change="changeFieldVisible($event)"
          :disabled="$attrs.disabled"
        >
          <template slot-scope="{ node, data }">
            <span :title="data.label">{{ data.label }}</span>
          </template>
        </el-cascader>
      </div>
      <el-select
        ref="selectField"
        v-model="filterItem.rightFilterField"
        v-if="inputType === 'attribute'"
        @change="rightListChange"
        class="right-input"
        placeholder="请选择属性"
        size="mini"
        value-key="fieldWid"
        :class="{ 'err-select': judgeRightDelete() }"
        :disabled="$attrs.disabled"
      >
        <el-option v-for="item in attributeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
      <el-cascader
        :ref="`filterItem${$attrs.groupIndex}${$attrs.filterItemIndex}`"
        v-model="filterItem.rightFilterField"
        v-if="isCodeField && inputType === 'code'"
        @change="rightTableChange"
        :props="{ emitPath: false, ...localProps }"
        :class="[
          `filterItem${$attrs.groupIndex}${$attrs.filterItemIndex}`,
          'w210',
          { 'ml6': !codeList.length },
          { 'err-select': judgeDelete() },
        ]"
        size="mini"
        :options="!!codeList.length ? codeList : fieldListView"
        :show-all-levels="false"
        :before-filter="chooseFirstOption"
        filterable
        clearable
        :separator="separatorSymbol"
        @visible-change="changeFieldVisible($event)"
        :disabled="$attrs.disabled"
      ></el-cascader>
      <el-autocomplete
        size="mini"
        v-if="inputType === 'value' && !isDate && globalFieldsMapItem.isQueryField"
        v-model="filterItem.rightFilterValue.filterValue"
        :fetch-suggestions="querySearch"
        placeholder="请输入内容"
      >
        <template slot-scope="{ item }">
          <div class="query-item-text" :title="item.value" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">
            {{ item.value }}
          </div>
        </template>
      </el-autocomplete>
      <el-input
        v-if="(inputType === 'value' && !isDate && !globalFieldsMapItem.isQueryField) || inputType === 'expression'"
        class="right-input"
        v-model="filterItem.rightFilterValue.filterValue"
        size="mini"
        :placeholder="inputType === 'expression' ? '请输入表达式' : '请输入值'"
        :disabled="$attrs.disabled"
      ></el-input>
      <el-date-picker
        v-if="inputType === 'value' && isDate && !isTime"
        prefix-icon="el-icon-date"
        class="right-input"
        size="mini"
        v-model="filterItem.rightFilterValue.filterValue"
        :type="isDateTimeCategory ? 'datetime' : isYm ? 'month' : 'date'"
        placeholder="请选择日期"
        :value-format="isDateTimeCategory ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
        @change="changeInput"
        :disabled="$attrs.disabled"
      ></el-date-picker>
      <el-time-picker
        v-if="inputType === 'value' && isDate && isTime"
        prefix-icon="el-icon-date"
        class="right-input"
        size="mini"
        v-model="filterItem.rightFilterValue.filterValue"
        placeholder="请选择时间"
        value-format="HH:mm:ss"
        @change="changeInput"
        :disabled="$attrs.disabled"
      ></el-time-picker>
    </div>
    <div class="setup-input" v-else-if="showSingleInputTpl">
      <el-input
        value="值"
        readonly
        class="left-input val-input"
        size="mini"
        :disabled="$attrs.disabled"
      ></el-input>
      <el-input
        class="right-input"
        @change="singleInputChange"
        v-model="filterItem.showRightField"
        size="mini"
        placeholder="请输入值"
        :disabled="$attrs.disabled"
      ></el-input>
    </div>
    <div class="setup-input" v-else-if="showDuplicateTpl">
      <el-input
        value="值"
        readonly
        class="left-input val-input"
        size="mini"
        :disabled="$attrs.disabled"
      ></el-input>
      <el-popover placement="bottom" class="right-input" style="margin-top: -1px;" width="210" trigger="manual" v-model="popoverControl">
        <div class="p-[2px]" style="padding: 2px;">
          <el-input
            size="mini"
            class="textarea-disabled-resize"
            type="textarea"
            placeholder="每行一个值，换行分隔"
            v-model="filterVal"
            :rows="3"
            :disabled="$attrs.disabled"
          ></el-input>
          <div class="text-right pr-[2px] mt-[4px]" style="margin-top: 4px;">
            <el-button size="mini" @click="popoverChange">取 消</el-button>
            <el-button size="mini" type="primary" @click="setFilterVal">确 定</el-button>
          </div>
        </div>
        <el-input
          slot="reference"
          ref="slotInput"
          @focus="slotInputFocus"
          size="mini"
          placeholder="请输入值"
          v-model="rightFilterFieldView"
          :disabled="$attrs.disabled"
        ></el-input>
      </el-popover>
    </div>
    <div class="setup-input" v-else-if="isBetweenCategory">
      <el-input
        class="left-input between-input"
        v-if="isNumber || isFromRoma"
        :type="isFromRoma ? 'text' : 'number'"
        size="mini"
        v-model="filterItem.between[0]"
        :placeholder="isFromRoma ? '请输入' : '请输入值'"
        :disabled="$attrs.disabled"
      ></el-input>
      <el-date-picker
        v-if="isDate && !isTime"
        prefix-icon="el-icon-date"
        class="left-input between-input"
        size="mini"
        v-model="filterItem.between[0]"
        :type="isDateTimeCategory ? 'datetime' : isYm ? 'month' : 'date'"
        placeholder="不限"
        :value-format="isDateTimeCategory ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
        @change="changeInput"
        :disabled="$attrs.disabled"
      ></el-date-picker>
      <el-time-picker
        v-if="inputType === 'value' && isDate && isTime"
        prefix-icon="el-icon-date"
        class="right-input between-input"
        size="mini"
        v-model="filterItem.between[0]"
        placeholder="请选择时间"
        value-format="HH:mm:ss"
        @change="changeInput"
        :disabled="$attrs.disabled"
      ></el-time-picker>
      <span class="mx-[6px]">和</span>
      <el-input
        class="right-input between-input"
        v-if="isNumber || isFromRoma"
        :type="isFromRoma ? 'text' : 'number'"
        size="mini"
        v-model="filterItem.between[1]"
        :placeholder="isFromRoma ? '请输入' : '请输入值'"
        :disabled="$attrs.disabled"
      ></el-input>
      <el-date-picker
        v-if="isDate && !isTime"
        prefix-icon="el-icon-date"
        class="right-input between-input"
        size="mini"
        v-model="filterItem.between[1]"
        :type="isDateTimeCategory ? 'datetime' : isYm ? 'month' : 'date'"
        placeholder="不限"
        :value-format="isDateTimeCategory ? 'yyyy-MM-dd HH:mm:ss' : 'yyyy-MM-dd'"
        @change="changeInput"
        :disabled="$attrs.disabled"
      ></el-date-picker>
      <el-time-picker
        v-if="inputType === 'value' && isDate && isTime"
        prefix-icon="el-icon-date"
        class="right-input between-input"
        size="mini"
        v-model="filterItem.between[1]"
        placeholder="请选择时间"
        value-format="HH:mm:ss"
        @change="changeInput"
        :disabled="$attrs.disabled"
      ></el-time-picker>
    </div>
  </div>
</template>

<script>
import { htmlFilterText, isEmpty, processString, wordsJoin } from '../utils'
// import { queryStandardDictContent } from 'cdsp_sharedKernel/service'
import fieldTypeIcon from './fieldTypeIcon.vue'

const queryStandardDictContent = () => {
  return Promise.resolve({
    data: [],
  })
}

export default {
  name: 'filterInputValue',
  components: { fieldTypeIcon },
  props: {
    separatorSymbol: {
      type: String,
      default: '/',
    },
    filterGroup: {
      type: Object,
      default: () => {},
    },
    filterItem: {
      type: Object,
      default: () => {},
    },
    optionsValue: {
      type: Array,
      default: () => {
        return [
          {
            label: '值',
            value: 'value',
          },
          {
            label: '字段',
            value: 'field',
          },
        ]
      },
    },
  },
  inject: {
    fieldTypeMap: { default: 'fieldTypeMap' },
  },
  watch: {
    // 'filterItem.rightFilterField'(val) {
    //   if(!val)return
    //   this.filterItem.showRightField = val
    //
    //   // delete this.filterItem.rightTableAlias
    // },
    'filterItem.rightFilterField': {
      handler(val) {
        if (!val) return
        this.filterItem.showRightField = val
        // if (this.inputType === 'field') {
        //   let item = this.fieldListView.find((v) => v.fieldId === val) || {}
        //   this.filterItem.rightDataSourceId = item.dataSourceId
        //   this.filterItem.rightSchemaName = item.schemaName
        // }
        this.$nextTick(() => {
          const curFieldList = this.inputType === 'attribute' ? this.attributeList : null
          const isDelete = curFieldList?.filter((f) => f.fieldId === val)?.length === 0
          const currentLabel = this.$refs.selectField?.selected.currentLabel
          if (isDelete && val && currentLabel === val && this.$refs.selectField) {
            // 处理已选字段被删除，回显展示
            this.$refs.selectField.selected.currentLabel = this.$refs.selectField.selectedLabel =
              this.filterItem.rightMetaTable.label
          }
        })
      },
      immediate: true,
      deep: true,
    },
    'filterItem.between'(val) {
      if (val.filter((v) => !!v).length === 2) {
        this.filterItem.showRightField = val.join('|')
        // this.filterItem.rightTableAlias = ''
      }
    },
    'filterItem.rightFilterValue.filterValue'(val) {
      if (!isEmpty(val)) {
        this.filterItem.showRightField = String(val)
        // this.filterItem.rightTableAlias = ''
      }
    },
  },
  computed: {
    // 左侧选入字段是否分组
    isFieldsGroup() {
      return !!this.$attrs.fieldGroupName
    },
    globalFieldsMapItem() {
      return this.$attrs.globalFieldsMap && this.filterItem.fieldWid
        ? this.$attrs.globalFieldsMap[this.filterItem.fieldWid] || {}
        : {}
    },
    optionsValueView() {
      const field = this.fieldList?.find((t) => t.value === this.filterItem.fieldWid) || {}
      let isDict = !!this.$attrs.originCodeListMap?.[field.duoteDictWid]
      return this.filterItem.leftFieldType?.toLowerCase() === 'code'
        ? [...this.optionsValue, { label: isDict ? '字典值' : '代码值', value: 'code' }]
        : this.optionsValue
    },
    fieldListView() {
      return this.$attrs.globalFieldsMap
        ? (this.globalFieldsMapItem.datas ?? []).map((t) => {
            return {
              label: t,
              value: t,
              field: t,
            }
          })
        : this.$attrs.fieldListView
    },
    // 是否共享交换的过滤
    isShareFilter() {
      return false
    },
    // 是否匹配罗马模式
    isFromRoma() {
      return this.$attrs.isFromRoma
    },
    compareType() {
      return this.filterItem.compareType
    },
    // 字段规整后的类型 比如date和datetime、timeStr都属于date 该类型只有text number date boolean
    conditionType() {
      return this.$attrs.conditionType
    },
    // 选中字段表存储真正的类型
    fieldType() {
      return this.$attrs.fieldType
    },
    isTime() {
      return this.fieldType === 'time'
    },
    isYm() {
      return this.fieldType === 'ym'
    },
    isNullCategory() {
      return ['IS NULL', 'IS NOT NULL'].includes(this.compareType)
    },
    isInCategory() {
      return ['IN LIST', 'NOT IN'].includes(this.compareType)
    },
    isEqualCategory() {
      return ['=', '<>'].includes(this.compareType)
    },
    isBetweenCategory() {
      return ['BETWEEN', 'NOT BETWEEN', 'between', 'notBetween'].includes(this.compareType)
    },
    isFk() {
      return this.conditionType === 'fk'
    },
    isShowAllCondition() {
      return this.$attrs.isShowAllCondition
    },
    isDate() {
      return this.conditionType === 'date'
    },
    isText() {
      return this.conditionType === 'text'
    },
    isNumber() {
      return this.conditionType === 'number'
    },
    isDateCategory() {
      return ['date'].includes(this.fieldType)
    },
    isDateTimeCategory() {
      return ['datetime', 'timestamp'].includes(this.fieldType)
    },
    fieldList() {
      return this.$parent.fieldList
    },
    attributeList() {
      return this.$parent.attributeList || []
    },
    // 显示可以多选值的控件
    showDuplicateTpl() {
      return this.isInCategory && (this.isText || this.isFk || this.isShowAllCondition)
    },
    // 显示选值和字段切换的控件
    showSelectValueOrFieldTpl() {
      const fkAction = this.isFk && ['=', '<>', '>', '<', '>=', '<='].includes(this.compareType)
      const allAction = this.isShowAllCondition && ['=', '<>', '>', '<', '>=', '<='].includes(this.compareType)
      const textAction = this.isText && this.isEqualCategory
      const numberAction = this.isNumber && ['=', '<>', '>', '<', '>=', '<='].includes(this.compareType)
      const dateAction = this.isDate && ['=', '<>', '>', '<', '>=', '<='].includes(this.compareType)
      return textAction || numberAction || dateAction || fkAction || allAction
    },
    // 显示单个值输入的控件
    showSingleInputTpl() {
      return (
        ((this.isText || this.isFk || this.isShowAllCondition) &&
          ['LIKE', 'NOT LIKE', 'STARTS WITH', 'NOT STARTS WITH', 'ENDS WITH', 'NOT ENDS WITH'].includes(this.compareType)) ||
        (this.isFromRoma && !['between', 'notBetween', 'isNull', 'notNull', 'isEmpty', 'notEmpty'].includes(this.compareType))
      )
    },
    isCodeField() {
      return this.inputType === 'code' && this.filterItem.leftFieldType?.toLowerCase() === 'code'
    },
  },
  data() {
    return {
      localProps: {},
      codeList: [],
      rightFilterFieldView: '',
      inputType: 'value',
      popoverControl: false,
      filterVal: '',
      betweenOperatorList: [
        { label: '<', value: '<' },
        { label: '<=', value: '<=' },
      ],
    }
  },
  created() {
    this.initData()
  },
  mounted() {
    this.rightTypeGetter(true)
    if (this.filterItem.showRightField) {
      this.setRightFilterFieldView()
    }
    if (this.filterItem.rightFilterField && this.inputType === 'field' && this.isFieldsGroup) {
      this.$refs[`filterItem${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`].inputValue =
        this.filterItem.rightFilterField
    }
  },
  methods: {
    isEmpty,
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
      }
    },
    querySearch(queryString, cb) {
      const restaurants = this.fieldListView
      const results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
      cb(results)
    },
    changeFieldVisible(visible) {
      if (!visible) {
        let cascader = this.$refs[`filterItem${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`]
        if (!cascader.presentText) {
          cascader.presentText = this.filterItem.rightFilterField
        }
      }
    },
    judgeDelete() {
      return (
        this.$attrs.isMarkErr &&
        this.filterItem.rightFilterField &&
        !this.fieldList.find((v) => v.value === this.filterItem.rightFilterField) &&
        this.filterItem.isField != 3
      )
    },
    judgeRightDelete() {
      return (
        this.$attrs.isMarkErr &&
        this.filterItem.rightFilterField &&
        !this.attributeList.find((v) => v.value === this.filterItem.rightFilterField)
      )
    },
    chooseFirstOption() {
      let e = new KeyboardEvent('keydown', { keyCode: 40, which: 40 })
      this.$nextTick(() => {
        let cascader = document.querySelector(`.filterItem${this.$attrs.groupIndex}${this.$attrs.filterItemIndex}`)
        cascader.dispatchEvent(e)
      })
    },
    popoverChange() {
      this.popoverControl = false
      if (!this.filterItem.showRightField) {
        this.rightFilterFieldView = ''
      }
    },
    singleInputChange(val) {
      this.$set(this.filterItem, 'between', [])
      this.filterItem.rightFilterValue.filterValue = val
      this.filterItem.rightFilterValue.filterValueArr = []
      this.filterItem.rightFilterValue.length = 200
    },
    rightTableChange(val, refName) {
      const rightFieldOpt = this.fieldList.find((v) => v.field === val || v.fieldId === val)
      this.filterItem.rightTableAlias = rightFieldOpt?.tableName
      if (this.$attrs.customName === 'chart-filter') {
        let label = ''
        const getLabel = (list) => {
          list?.forEach((t) => {
            if (t.value === this.filterItem.rightFilterField) {
                label = t.field
                this.filterItem.rightFieldDisplayName = t.compareId
                this.filterItem.rightKey = t.field
            }
            if (!label && t.children) {
              getLabel(t.children)
            }
          })
        }
       getLabel(this.fieldListView)
      }
    },
    rightListChange(val) {
      let item = this.attributeList.find((v) => v.fieldWid == val)
      this.filterItem.rightMetaTable = { ...item }
    },
    initData() {
      this.$set(this.filterItem, 'between', ['', ''])
      if (this.filterItem.showRightField.indexOf('|') && this.isBetweenCategory) {
        this.$set(this.filterItem, 'between', this.filterItem.showRightField.split('|'))
      }
      if (this.showSingleInputTpl) {
        this.filterItem.rightFilterField = ''
        this.singleInputChange(this.filterItem.showRightField)
      }
      if (this.showDuplicateTpl && this.filterItem.showRightField) {
        this.filterVal = this.filterItem.showRightField.replace(/;/g, '\n')
        this.setFilterVal()
      }
      if (this.showSelectValueOrFieldTpl && !(this.isShareFilter && this.isFromRoma)) {
        this.inputType = !!this.filterItem.rightFilterField
          ? (this.attributeList || []).length > 0
            ? 'attribute'
            : this.filterItem.hasOwnProperty('isField') && !this.filterItem.isField
            ? 'value'
            : 'field'
          : 'value'
        if (this.filterItem.leftFieldType?.toLowerCase() === 'code' && this.filterItem.isField === 3) {
          this.inputType = 'code'
        }
        this.handlerCodeField()
      } else {
        this.inputType = 'value'
        this.filterItem.rightFilterValue.filterValue = this.filterItem.showRightField
      }
    },
    setRightFilterFieldView() {
      const filterValue = this.filterItem.rightFilterValue.filterValue.replace(/'/g, '')
      this.filterVal = filterValue?.replace(/;/g, '\n')
      if (filterValue && !this.filterItem.rightFilterValue.filterValueArr && this.showDuplicateTpl) {
        this.filterItem.rightFilterValue.filterValueArr = filterValue.split(';').filter((v) => !!v)
      }
      const filterValueArr = (this.filterItem.rightFilterValue.filterValueArr || []).filter((v) => !!v)
      if (filterValueArr?.length > 1) {
        this.rightFilterFieldView = `${filterValueArr[0]} 等${filterValueArr.length}个值`
      } else {
        this.rightFilterFieldView = filterValueArr?.[0]
      }
      if (!!filterValueArr?.length) {
        this.filterItem.showRightField = filterValueArr?.join(';')
        this.filterItem.rightFilterValue.filterValue = filterValueArr?.join(';')
      }
      // this.filterItem.rightTableAlias = ''
    },
    changeInput() {},
    inputTypeChange() {
      this.filterItem.rightFilterField = ''
      this.filterItem.rightFilterValue.filterValue = ''
      this.filterItem.rightFilterValue.filterType = ''
      this.rightTypeGetter()
      this.handlerCodeField()
    },
    async handlerCodeField() {
      this.codeList = []
      this.localProps = {}
      if (!this.isCodeField) return
      const field = this.fieldList.find((t) => t.value === this.filterItem.fieldWid) || {}
      if (!field.duoteDictWid) return
      const deepHandlerLeafList = (list) => {
        list.forEach((t) => {
          if (!t.list?.length) {
            delete t.list
          }
          if (t.list) {
            deepHandlerLeafList(t.list)
          }
        })
      }
      if (this.$attrs.codeListMap[field.duoteDictWid]) {
        this.codeList = this.$attrs.codeListMap[field.duoteDictWid]
      } else {
        const { contentInfo } = await queryStandardDictContent({
          wid: field.duoteDictWid,
          n: Math.random(),
        })
        const deep = (list) => {
          list?.forEach((t) => {
            t.dictNameLabel = `${t.dictName}(${t.dictCode})`
            if (t.list?.length) {
              deep(t.list)
            }
          })
        }
        deep(contentInfo)
        deepHandlerLeafList(contentInfo)
        this.$attrs.codeListMap[field.duoteDictWid] = contentInfo
        this.codeList = contentInfo
      }
      this.localProps = {
        checkStrictly: true,
        emitPath: false,
        label: 'dictNameLabel',
        value: 'dictCode',
        children: 'list',
      }
    },
    rightTypeGetter(isInit) {
      let isTask = false
      if (isInit && isTask) return
      if (isInit && this.filterItem.isField === 9) {
        this.inputType = 'expression'
        return
      }
      this.filterItem.isField = 0
      if ((this.inputType === 'value' || this.showSingleInputTpl) && this.$attrs.rightTypeHttpFlag && !this.isDate) {
        this.filterItem.rightFilterValue.filterType = 'String'
        this.filterItem.rightFilterField = ''
      }
      if (this.showSelectValueOrFieldTpl && this.inputType === 'field') {
        this.filterItem.isField = 1
      }
      if (this.inputType === 'attribute') {
        this.filterItem.isField = 2
      }
      if (this.inputType === 'expression') {
        this.filterItem.isField = 9
      }
      if (this.inputType === 'code') {
        this.filterItem.isField = 3
      }
    },
    slotInputFocus() {
      if (this.filterItem.showRightField) {
        this.filterVal = this.filterItem.showRightField.replace(/;/g, '\n')
        this.setFilterVal()
      } else {
        this.filterVal = ''
      }
      this.popoverControl = true
      this.$refs.slotInput.blur()
    },
    setFilterVal() {
      this.$set(
        this.filterItem.rightFilterValue,
        'filterValueArr',
        this.filterVal.split(/\n/).filter((v) => !!v)
      )
      this.popoverControl = false
      if (!this.filterItem.rightFilterValue?.filterValueArr?.length) {
        this.filterItem.rightFilterValue.filterValue = ''
        this.filterItem.showRightField = ''
      }
      this.setRightFilterFieldView()
    },
    filterNode(data, value) {
      if (!value) return true
      return data.label.toLowerCase().includes(value.toLowerCase())
    },
  },
}
</script>

<style scoped lang="less">
.setup-input {
  display: flex;
  align-items: center;

  /deep/ .left-input {
    width: 90px;
    margin-left: 6px;

    .el-input__inner {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  /deep/ .right-input {
    width: 210px;

    .el-input__inner {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }

  .val-input {
    width: 46px;
  }

  .operator-input {
    width: 60px;
  }

  .between-input {
    width: 140px;
  }
}
</style>
